module.exports = __webpack_public_path__ + "static/media/ukraine.9a8f121d.svg";